import script from "./IPackageEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./IPackageEvent.vue?vue&type=script&setup=true&lang=js"

import "./IPackageEvent.vue?vue&type=style&index=0&id=92da6dfe&lang=scss"

const __exports__ = script;

export default __exports__